import { AfterContentInit, Component, ComponentFactoryResolver, Inject, ViewChild } from '@angular/core';
import { DialogTemplateInjectorDirective } from '../dialog-template-injector.directive';
import { InjectedDialogComponent } from '../xpo-dialog-manager.service';
import { AlertDialogData } from '../../interfaces';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-alert-wrapper',
  templateUrl: './alert-wrapper.component.html',
  styleUrls: ['./alert-wrapper.component.scss'],
})
export class AlertWrapperComponent implements AfterContentInit {
  @ViewChild(DialogTemplateInjectorDirective) messageContent: DialogTemplateInjectorDirective;

  constructor(private dialogRef: MatDialogRef<AlertWrapperComponent>, @Inject(MAT_DIALOG_DATA) public data: AlertDialogData, private componentFactoryResolver: ComponentFactoryResolver) {}

  ngAfterContentInit() {
    if (this.data.contentComponent) {
      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.data.contentComponent);
      const componentRef = this.messageContent.viewContainerRef.createComponent(componentFactory);
      (componentRef.instance as InjectedDialogComponent).dataObservable = this.data.injectedData;
    }
  }

  handleCloseClick(): void {
    this.dialogRef.close();
  }
}
